module.exports = __webpack_public_path__ + "img/full6-min.37991e7c.png";